import EmptyPage from "../../components/EmptyPage";

export default function PageNotFound() {
  return (
    <div className="page-body"><EmptyPage text={"Hmmm! Page not found. Did you navigate right?"}/></div>
  )
}
